import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import UxSignalsInvitation from '@helsenorge/core-cms/uxsignals-invitation';
import { setSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';
const UxSignalsWrapper = props => {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = () => {
        setIsVisible(false);
        setSurveysCookie(props.survey.id);
    };
    if (!isVisible) {
        return null;
    }
    return (_jsx(UxSignalsInvitation, { component: props.survey.component, id: props.survey.surveyId, closeButtonText: props.survey.closeButtonText, disclaimerText: props.survey.disclaimerText, onClose: handleClose }));
};
export default UxSignalsWrapper;
